import React from 'react'
import { useMain } from '../../Hook/Main'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
function Index() {
    const { data } = useMain();
    return (
        <Layout>
            <HeaderMain lable="بایدها و نبایدها" />
            <div className="all-rule">
                <div className="p-rule">
                    <h3 className="h-rule">توافق نامه کاربری</h3>
                    <p>{ data.Rules}</p>
                </div>
            </div>
        </Layout>
    )
}

export default Index